import * as React from "react";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../store/index";
import { useTranslation } from "react-i18next";

interface IProps {
    retryButtonText?: string;
    onRetryCallBack?: any;
    closeButtonText?: string;
    onCloseButtonCallBack: any;
    attemptStatus: string;
}

const L3NotEnoughInfoComponent: React.FunctionComponent<IProps> = (props) => {
    const partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );

    const { t: tLang } = useTranslation();
    let strRetryButtonText = tLang("dashboard.creditScore.L3NotEnoughInfoComp.tryAgainBtnText");

    // set default value for props, if not passed
    if (props.retryButtonText != null) {
        strRetryButtonText = props.retryButtonText;
    }

    const onRetry = () => {
        if (props.onRetryCallBack != null) {
            props.onRetryCallBack({ status: "success", data: "retry" });
        }
    };

    const onClose = () => {
        if (props.onCloseButtonCallBack != null) {
            props.onCloseButtonCallBack({ status: "success", data: "close" });
        }
    };

    return (
        <React.Fragment>
            <div className="dialog-header">
                <h3 className="box-title">{tLang("dashboard.creditScore.L3NotEnoughInfoComp.title")}</h3>
            </div>
            <div className="dialog-body">
                <div className="box-description">
                    <p>
                        {props.attemptStatus === "locked-not-enough-info" ? (
                            <React.Fragment>{tLang("dashboard.creditScore.L3NotEnoughInfoComp.msg1")}&nbsp;</React.Fragment>
                        ) : (
                                <React.Fragment>{tLang("dashboard.creditScore.L3NotEnoughInfoComp.msg2")}&nbsp;</React.Fragment>
                        )}
                        {tLang("dashboard.creditScore.L3NotEnoughInfoComp.msg3")}{" "}
                        <a href={'tel:"' + partnerPhoneNumber + '"'}>{partnerPhoneNumber}</a>&nbsp; {tLang("dashboard.creditScore.L3NotEnoughInfoComp.msg4")}.
                    </p>
                </div>
            </div>
            <div className="dialog-footer">
                <div className="row between-xs">
                    {props.closeButtonText != null && (
                        <div className="col-xs col-no-gutter flex-grow-null">
                            {props.attemptStatus !== "locked-not-enough-info" && (
                                <button type="button" className="btn-default btn-link btn-no-padding btn-no-border" onClick={() => onClose()}>
                                    <span className="btn-text">{props.closeButtonText}</span>
                                </button>
                            )}
                        </div>
                    )}
                    <div className="col-xs col-no-gutter flex-grow-null">
                        {props.attemptStatus === "locked-not-enough-info" ? (
                            <button type="button" className="btn-default btn-primary" onClick={() => onClose()}>
                                <span className="btn-text">{props.closeButtonText}</span>
                            </button>
                        ) : (
                            <button type="button" className="btn-default btn-primary" onClick={onRetry}>
                                <span className="btn-text">{strRetryButtonText}</span>
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default L3NotEnoughInfoComponent;
